import { FormGroup, FormControl, Validators } from "@angular/forms";

export class SeedingReportFormGroup extends FormGroup {
    constructor() {
        const controlSet = {
            startDate: new FormControl(null, Validators.required),
            endDate: new FormControl(null, Validators.required),
            crop: new FormControl(),
            containerType: new FormControl(),
            substrate: new FormControl()
        };
        super(controlSet);

        this._startDate = controlSet.startDate;
        this._endDate = controlSet.endDate;
        this._crop = controlSet.crop;
        this._containerType = controlSet.containerType;
        this._substrate = controlSet.substrate;
    }

    private _startDate: FormControl;
    private _endDate: FormControl;
    private _crop: FormControl;
    private _containerType: FormControl;
    private _substrate: FormControl;

    public get startDateFormControl(): FormControl {
        return this._startDate;
    }

    public get endDateFormControl(): FormControl {
        return this._endDate;
    }

    public get cropFormControl(): FormControl {
        return this._crop;
    }

    public get containerTypeFormControl(): FormControl {
        return this._containerType;
    }

    public get substrateFormControl(): FormControl {
        return this._substrate;
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/seeding-report-form/seeding-report-form-group.ts